import { jsx as _jsx } from "react/jsx-runtime";
import { MenuList as MuiMenuList, } from '@mui/material';
export const MenuList = ({ children, ...props }) => (_jsx(MuiMenuList, { ...props, children: children }));
